import { fetch } from '@/utils/http'

export default {
  //获取任务列表
  queryTask: (url, params) => fetch('post', url, params),

  createTask: (url, params) => fetch('post', url, params), //任务设置保存任务
  testTask: (url, params) => fetch('get', url, params), //测试连通性

  addTargetChain: (url, params) => fetch('post', url, params), //添加原链信息
  taskDetails: (url, params) => fetch('get', url, params), //任务详情

  getEditData: (url, params) => fetch('get', url, params), //获取修改数据
  handleStart: (url, params) => fetch('get', url, params), //开始迁移
  handleRestart: (url, params) => fetch('get', url, params), //重启任务

  handleStopApi: (url, params) => fetch('get', url, params), //停止任务

  addServer: (url, params) => fetch('get', url, params) //停止任务
}
